import React, { useState, useEffect } from 'react';
import './css/Formulario_Pacientes.css';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const FormularioPaciente = () => {
  const [formData, setFormData] = useState({
    idPaciente: '',
    iniciales: '',
    fechaNacimiento: '',
    sexo: '',
    fechaReclutamiento: '',
    protocolo: '521',
    email: '', // Aquí guardaremos el email del administrador seleccionado
  });

  const [administradores, setAdministradores] = useState([]); 
  const navigate = useNavigate();

  // Manejo de cambios en los inputs normales
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Manejo especial del select de administradores
  const handleAdminChange = (e) => {
    const selectedId = e.target.value;
    const selectedAdmin = administradores.find(admin => admin.id.toString() === selectedId);

    setFormData({
      ...formData,
      idAdministrador: selectedId,
      email: selectedAdmin ? selectedAdmin.email : '', // Guardamos su email
    });
  };

  // Obtener siguiente idPaciente disponible
  const getNextIdPaciente = async () => {
    try {
      const response = await fetch('https://api.weareinfinite.mx/paciente/read');
      const data = await response.json();
      const patientIds = data.pacientes.map(patient => parseInt(patient.idPaciente, 10));
      let nextId = 1;
      while (patientIds.includes(nextId)) nextId++;
      return nextId;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: '¡Error al verificar ID!',
        text: 'Hubo un problema al verificar el ID del paciente.',
      });
      return 1;
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      const newIdPaciente = await getNextIdPaciente();
      setFormData(prev => ({ ...prev, idPaciente: newIdPaciente.toString() }));

      try {
        const response = await fetch('https://api.weareinfinite.mx/admin/administradores');
        const data = await response.json();

        const adminsConEmail = data
          .filter(admin => (admin.id === 20 || admin.id === 21) && admin.email)// Filtra solo los administradores con un email válido
          .map(admin => ({
            id: admin.id,
            email: admin.email, // Usamos email en lugar de nombre
          }));

        setAdministradores(adminsConEmail);
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: '¡Error!',
          text: 'No se pudieron cargar los administradores.',
        });
      }
    };
    fetchInitialData();
  }, []);

  // Envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { iniciales, fechaNacimiento, sexo, fechaReclutamiento, email } = formData;

    if (!iniciales || !fechaNacimiento || !sexo || !fechaReclutamiento || !email) {
      Swal.fire({
        icon: 'error',
        title: 'Campos incompletos',
        text: 'Por favor complete todos los campos.',
      });
      return;
    }

    const dataToSend = {
      ...formData,
      idProtocolo: formData.protocolo,
    };

    delete dataToSend.protocolo;

    try {
      const response = await fetch('https://api.weareinfinite.mx/paciente/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToSend),
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: '¡Paciente registrado exitosamente!',
          text: 'El paciente ha sido registrado.',
          showConfirmButton: false,
          timer: 2000,
        });
        setTimeout(() => navigate('/Exel/SMET-40429'), 2000);
      } else {
        Swal.fire({
          icon: 'error',
          title: '¡Error al registrar paciente!',
          text: data.mensaje || 'Verifique los datos e intente nuevamente.',
        }).then(() => navigate('/Exel/SMET-40429'));
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: '¡Error de conexión!',
        text: 'Hubo un problema al conectar con el servidor.',
      }).then(() => navigate('/Exel/SMET-40429'));
    }
  };

  return (
    <div className="container">
      <h2>AÑADIR SUJETO</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" name="idPaciente" value={formData.idPaciente} readOnly />
        <input type="text" name="iniciales" placeholder="Iniciales" value={formData.iniciales} onChange={handleChange} required />

        <div className="field-group">
          <label htmlFor="fechaNacimiento">Fecha de Nacimiento</label>
          <input type="date" name="fechaNacimiento" value={formData.fechaNacimiento} onChange={handleChange} required />
        </div>

        <div className="field-group">
          <label>Sexo</label>
          <div className="radio-group">
            <label className="radio-button">
              <input type="radio" name="sexo" value="Masculino" checked={formData.sexo === 'Masculino'} onChange={handleChange} />
              <span>Masculino</span>
            </label>
            <label className="radio-button">
              <input type="radio" name="sexo" value="Femenino" checked={formData.sexo === 'Femenino'} onChange={handleChange} />
              <span>Femenino</span>
            </label>
          </div>
        </div>

        <div className="field-group">
          <label htmlFor="fechaReclutamiento">Fecha de Reclutamiento</label>
          <input type="date" name="fechaReclutamiento" value={formData.fechaReclutamiento} onChange={handleChange} required />
        </div>

        {/* Select de administradores */}
        <div className="field-group">
          <label htmlFor="idAdministrador">Seleccione Administrador</label>
          <select
            name="idAdministrador"
            id="idAdministrador"
            value={formData.idAdministrador || ''}
            onChange={handleAdminChange}
            required
          >
            <option value="">-- Seleccione administrador --</option>
            {administradores.length > 0 ? (
              administradores.map(admin => (
                <option key={admin.id} value={admin.id}>
                  {admin.email} {/* Muestra el email del administrador */}
                </option>
              ))
            ) : (
              <option value="">No hay administradores disponibles</option>
            )}
          </select>
        </div>

        <button type="submit">Enviar</button>
      </form>
    </div>
  );
};

export default FormularioPaciente;
